/**
 * @generated SignedSource<<5eff8f597850f4358962182cfeaed5b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type YesNoEtc = "etc" | "no" | "yes";
export type businessStartQuestionQuery$variables = {
  bmanTin?: string | null | undefined;
  refundHistoryId: string;
};
export type businessStartQuestionQuery$data = {
  readonly getSurveyBusinessAnswer: {
    readonly businessAnswer: ReadonlyArray<{
      readonly isStartBusinessDirectly: YesNoEtc | null | undefined;
    }> | null | undefined;
    readonly result: boolean;
  };
};
export type businessStartQuestionQuery = {
  response: businessStartQuestionQuery$data;
  variables: businessStartQuestionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bmanTin"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundHistoryId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bmanTin",
        "variableName": "bmanTin"
      },
      {
        "kind": "Variable",
        "name": "refundHistoryId",
        "variableName": "refundHistoryId"
      }
    ],
    "concreteType": "SurveyBusinessAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessAnswer",
        "kind": "LinkedField",
        "name": "businessAnswer",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isStartBusinessDirectly",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "businessStartQuestionQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "businessStartQuestionQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7f49c3f035eca7a0468ab14c7b2aa56c",
    "id": null,
    "metadata": {},
    "name": "businessStartQuestionQuery",
    "operationKind": "query",
    "text": "query businessStartQuestionQuery(\n  $refundHistoryId: String!\n  $bmanTin: String\n) {\n  getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {\n    result\n    businessAnswer {\n      isStartBusinessDirectly\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "357e6a459eccc6403591bec1c472134e";

export default node;
